import React from 'react';
import PropTypes from 'prop-types';
import CardActionArea from '@material-ui/core/CardActionArea';

import MuiCard from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import styledBy from 'bento-ordering/base/utils/styleHelpers';
const styles = {
  root: {
    cursor: styledBy('disabled', {
      true: 'default',
      default: 'pointer'
    })
  }
};

const Card = ({
  children,
  disabled,
  classes,
  handleClick,
  role,
  dataTestId
}) => {
  return (
    <MuiCard>
      <CardActionArea
        onClick={handleClick}
        disabled={disabled}
        classes={classes}
        role={role}
        data-testid={dataTestId}
      >
        {children}
      </CardActionArea>
    </MuiCard>
  );
};

Card.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  classes: PropTypes.shape(0),
  handleClick: PropTypes.func,
  role: PropTypes.string,
  dataTestId: PropTypes.string
};

export default withStyles(styles)(Card);
